// extracted by mini-css-extract-plugin
export default {"schoolInfo":"schoolInfo_schoolInfo__4A08W","img-box":"schoolInfo_img-box__FBzqR","schoolInfo__list":"schoolInfo_schoolInfo__list__19Nfj"};